// extracted by mini-css-extract-plugin
module.exports = {"body":"Body_body__1boZE","regular":"Body_regular__zAKD2","bold":"Body_bold__8OOp4"};